import axios from "@/plugins/axios";

export function getData() {
  return axios({
    url: "Website/GetWebsiteAsync",
    method: "GET",
  });
}

export function addViewsByNickname(nickname) {
  return axios({
    url: "friend",
    method: "POST",
    params: {
      nickname,
    },
  });
}
